import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    UpdateInventoryStockAdjustmentNoteInput,
    UpdateInventoryStockAdjustmentNoteResponse,
} from '../../types/inventory';

const updateStockAdjustmentNote = async (
    sessionId: string,
    input: UpdateInventoryStockAdjustmentNoteInput,
): Promise<UpdateInventoryStockAdjustmentNoteResponse> => {
    const { data } = await axios.post(
        `${API_URL}/inventory/adjustments/update-note`,
        input,
        {
            headers: { Authorization: sessionId },
        },
    );
    return data;
};

export const useUpdateInventoryStockAdjustmentNote = (
    options?: UseMutationOptions<
        UpdateInventoryStockAdjustmentNoteResponse,
        unknown,
        UpdateInventoryStockAdjustmentNoteInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: UpdateInventoryStockAdjustmentNoteInput) =>
            updateStockAdjustmentNote(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};
